export enum MenuState {
  Closed = 'closed',
  Open = 'open',
}

export enum MenuToggleModifier {
  Base = 'base',
}
